import {getBaseUrl} from "./get-api-url";

const fetchValidation = (uid) => fetch(`${getBaseUrl()}api/validate-uid/${encodeURIComponent(uid)}`);

export const validateAccount = async (uid) => {
    const res = await fetchValidation(uid);
    if (res.status === 200) {
        const responseJson = await res.json();
        return responseJson.success;
    } else {
        return false;
    }
}

/*
    Returns full response which is {success: boolean, language: string}
*/
export const validateAccountV2 = async (uid) => {
    const res = await fetchValidation(uid);
    if (res.status === 200) {
        return res.json();
    } else {
        return {success: false};
    }
}
